<template>
  <v-dialog persistent :value="show" max-width="1000">
    <v-card>
      <button style="width: 1px; height: 1px; display: none"></button>
      <div class="text-xs-right">
        <v-btn name="close" small flat fab @click="onClose">
          <v-icon>close</v-icon>
        </v-btn>
      </div>

      <v-card-text>
        <div class="list-categories pb-3">
          <div
            class="category"
            v-for="(subcategory, index) in subcategorylist"
            :key="'subcategory_' + index"
          >
            <ecommerce-sub-category-edit
              :subcategorylist="subcategorylist"
              v-model="subcategorylist[index]"
              :prefix="prefix"
              @onDelete="onDeleteSubCategory(index, $event)"
            >
              <template slot="move">
                <move-vertical
                  :index="index"
                  :max="subcategorylist.length"
                  @onMove="onMove(index, $event)"
                  style="
                    width: 20px;
                    min-width: 20px;
                    display: inline-block;
                    float: left;
                    margin-right: 10px;
                  "
                >
                  <div></div>
                </move-vertical>
              </template>
            </ecommerce-sub-category-edit>
          </div>
          <div>
            <div
              class="btn-add text-xs-center"
              style="padding: 20px 0"
              v-if="!isAdd"
              @click="onAddNew"
            >
              <em class="fa fa-plus" />
              {{ $t('Add new categories') }}
            </div>
            <div class="category" v-else>
              <div style="margin-bottom: 0">
                <div v-if="isLoading" style="padding-top: 15px; padding-bottom: 15px">
                  <pulse-loader :color="$vuetify.theme.primary" :size="'15px'"></pulse-loader>
                </div>
                <template v-else>
                  <div class="mb-2">
                    <v-layout wrap class="pa-2">
                      <v-flex xs12 sm3 class="form-control">
                        <div
                          class="pb-3 form-control"
                          :class="{ 'has-error': errors.has('subcategoryphoto') }"
                        >
                          <div class="primary--text">
                            Subcategory Photo: <span class="red--text">*</span>
                          </div>
                          <uploadfile
                            :data-vv-as="$t('subcategoryphoto')"
                            name="Photo URL"
                            v-validate="`required`"
                            v-model="newSubCategory.photo_url"
                            style="max-width: 250px"
                          ></uploadfile>

                          <div class="text-error" v-show="errors.has('subcategoryphoto')">
                            {{ errors.first('subcategoryphoto') }}
                          </div>
                        </div>
                      </v-flex>
                      <v-flex xs12 sm9 class="pl-4">
                        <div
                          class="form-control"
                          :class="{ 'has-error': errors.has('memberLevel') }"
                        >
                          <div class="primary--text">
                            Member Level: <span class="red--text">*</span>
                          </div>
                          <v-radio-group
                            v-validate="'required'"
                            v-model="category"
                            :data-vv-as="$t('Member Level')"
                            name="memberLevel"
                            row
                          >
                            <template v-for="(category, index) in categorylist">
                              <v-radio
                                color="primary"
                                :key="index"
                                :label="category.name"
                                :value="category.id"
                              ></v-radio>
                            </template>
                          </v-radio-group>
                          <span class="text-error" v-if="errors.has('memberLevel')">{{
                            errors.first('memberLevel')
                          }}</span>
                        </div>
                        <div
                          class="form-control pt-4"
                          :class="{ 'has-error': errors.has('subcategoryname') }"
                          style="width: 100%"
                        >
                          <input
                            v-validate="`required`"
                            ref="newSubCategory"
                            type="text"
                            name="subcategoryname"
                            v-model="newSubCategory.name"
                            :placeholder="'Enter Sub Category Name'"
                            :data-vv-as="$t('Sub Category Name')"
                          />
                          <span class="text-error" v-if="errors.has('subcategoryname')">{{
                            errors.first('subcategoryname')
                          }}</span>
                        </div>
                      </v-flex>
                    </v-layout>
                    <div class="text-xs-center">
                      <v-btn outline color="grey" @click="onCancelAddSubCategory">{{
                        $t('cancel')
                      }}</v-btn>
                      <v-btn depressed color="primary" @click="onAddSubCategory">{{
                        $t('Save')
                      }}</v-btn>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>

          <!-- <div v-if="!isAdd">
          <v-btn @click="onAddNew">Click</v-btn>
        </div>
        <div v-else>yes</div> -->
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import MoveVertical from '@/components/elements/MoveVertical'
import ecommerceSubCategoryEdit from './ecommerce-sub-category-edit'
import FilterCategory from './FilterCategory.vue'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import api from '@/api'
import draggable from 'vuedraggable'
import uploadfile from '@/components/elements/uploadfile'

export default {
  props: ['value', 'show', 'prefix', 'categorylist'],
  computed: {
    subcategoryname() {
      return this.subcategorylist.map((v) => v.name)
    },
    subcategoryphoto() {
      return this.subcategorylist.map((v) => v.photo_url)
    },
    pageid: function () {
      return this.$store.state.selectedBot.pageid
    }
  },
  data: function () {
    return {
      subcategorylist: this.value,
      // currentCategory: null,
      currentSubCategory: null,
      // newCategory: {
      //   name: null
      // },
      isLoading: false,
      newSubCategory: {
        name: null
      },
      category: null,
      showEdit: false,
      isAdd: false
    }
  },
  mounted: function () {},
  components: {
    // 'ecommerce-category-edit': ecommerceCategoryEdit,
    'ecommerce-sub-category-edit': ecommerceSubCategoryEdit,
    draggable,
    PulseLoader,
    MoveVertical,
    FilterCategory,
    uploadfile
  },
  methods: {
    onClose() {
      this.$emit('close')
    },
    onMove(index, direction) {
      var vm = this
      if (direction == 'up') {
        vm.subcategorylist.splice(index, 0, vm.subcategorylist.splice(index - 1, 1)[0])
      } else if (direction == 'down') {
        vm.subcategorylist.splice(index, 0, vm.subcategorylist.splice(index + 1, 1)[0])
      }
      this.checkMove()
    },
    onAddNew: function () {
      var vm = this
      this.isAdd = true
      vm.$nextTick(function () {
        vm.$refs.newSubCategory.focus()
      })
    },
    close: function () {
      let vm = this
      vm.showEdit = false
      vm.nextTick(function () {
        // vm.$emit('input',vm.product)
      })
    },
    checkMove: function (e) {
      // e.newIndex
      // e.oldIndex
      let vm = this
      let input = []
      input = vm.subcategorylist.map((el, index) => {
        return { id: el.id, priority: index }
      })

      api.putprioritycategories({ input, pageid: this.pageid }, function (error, response) {
        if (error) {
          console.error(error)
          vm.isLoading = false
          return
        }
      })

      vm.$emit('input', vm.subcategorylist)
    },
    onEditSubCategory: function (index) {
      this.currentSubCategory = this.subcategorylist[index]
      this.showEdit = true
    },
    onSelectCategory: function (index) {
      this.currentSubCategory = this.subcategorylist[index]
    },
    // pressAddEnter: function(e) {
    //   if (e.keyCode === 13) {
    //     this.onAddCategory()
    //   }
    // },
    onCancelAddSubCategory: function () {
      var vm = this
      vm.newSubCategory.name = ''
      vm.isAdd = false
    },
    onAddSubCategory: function () {
      let vm = this
      vm.$validator.validateAll().then((result) => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }
        if (vm.newSubCategory.name == null || vm.newSubCategory.name.trim() == '') {
          vm.newSubCategory.name = ''
          vm.isAdd = false
          return false
        }
        vm.newSubCategory.name = (vm.prefix ? vm.prefix + '/' : '') + vm.newSubCategory.name
        let data = {
          pageid: vm.pageid,
          name: vm.newSubCategory.name,
          category_id: vm.category,
          photo_url: vm.newSubCategory.photo_url
        }
        vm.isLoading = true
        api.postLamyGiftSubCategory(data, function (error, response) {
          if (error) {
            console.error(error)
            vm.isLoading = false
            return
          }

          vm.newSubCategory.id = response.id
          // vm.newSubCategory.subcategories = []

          vm.subcategorylist.push(vm.newSubCategory)
          vm.newSubCategory = { name: null }
          vm.category = null
          vm.isAdd = false
          vm.isLoading = false
          vm.$emit('input', vm.subcategorylist)
          vm.$emit('onSubCategoryChange')
        })
      })
    },
    onDeleteSubCategory: function (index, subCategoryId) {
      let vm = this
      vm.$swal
        .fire({
          title: vm.$t('Do you want to delete {name}?', {
            name: vm.subcategorylist[index].name.replace(/\<|\>/g, '')
          }),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true,
          focusConfirm: true
        })
        .then((result) => {
          if (result.value) {
            let data = {
              sub_category_id: subCategoryId,
              pageid: vm.pageid
            }

            api.deleteLamyGiftSubCategory(data, function (error, response) {
              if (error) {
                console.error(error)
                return
              }

              vm.subcategorylist.splice(index, 1)
              vm.$emit('input', vm.subcategorylist)
              vm.$emit('onSubCategoryChange')
              vm.$emit('deleteSubCategory', subCategoryId)
            })
          }
        })
    }
  },
  watch: {
    value: function (newVal, oldVal) {
      this.subcategorylist = newVal
    }
  }
}
</script>

<style>
.list-category-group {
  text-decoration: none;
  list-style-type: none;
  padding-left: 0px;
}

.list-category:first-child {
  border-top: 1px solid #eee;
}

.list-category {
  padding: 10px;

  border-bottom: 1px solid #eee;
  border-left: 1px solid #eee;
  border-right: 1px solid #eee;
}

.list-category.active {
  background-color: #007bff;
  color: white;
}

.grab {
  cursor: -webkit-grab;
  cursor: grab;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/lamy/GiftSubCategory.vue